"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.env = void 0;
exports.env = {
    dev: false,
    prod: true,
    showEnvName: false,
    envName: 'Prod 1',
    enableZendesk: true,
    enableGraphQLPlayground: true,
    zendeskUrl: 'https://static.zdassets.com/ekr/snippet.js?key=dcffac06-c21d-4e78-9c0a-e9a0cd9cbcc8',
    apis: {
        support: 'https://opsbase.help.ideagen.com',
        opsbase: 'https://app.opsbase.com',
        graphql: 'https://api.opsbase.com/v0/graphql',
        auth: 'https://api.opsbase.com/v0/auth',
        images: 'https://api.opsbase.com/v0/images',
        webhooks: 'https://api.opsbase.com/v0/webhooks',
    },
    cognito: {
        region: 'eu-west-1',
        identityPoolId: 'eu-west-1:d88bdf66-fb2d-482e-b2ea-bc4c9b9b3c65',
        userPoolId: 'eu-west-1_Lt5lqFGe9',
        userPoolWebClientId: 'aj8vimqrrg972vp5f68hu8h3h',
    },
    googleMap: {
        apiKey: 'AIzaSyBkDqtvMtYr-BDJlm3hq9Vo7qQU0DsXmyw',
    },
    googleAnalytics: {
        key: 'G-YF367PZF5Z',
    },
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.opsboard',
    appStoreUrl: 'https://apps.apple.com/gb/app/opsbase/id1458068032',
};
exports.default = exports.env;
